import SortableTableHeading from './SortableTableHeading.vue'

const tablesComponents = [SortableTableHeading]

export default tablesComponents
